import React, { useContext, useState, useEffect, useRef } from 'react';
import { Link, useLocation  } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import logo from '../Images/logo.png'; 
import bag from '../Images/bag-happy.png';
import search from '../Images/searchNew.png';
import arrowDownImage from '../Images/arrowdown.png'; 
import menuIcon from '../Images/more.png';
import closeIcon from '../Images/close.png';
import eyeIcon from '../Images/view.png'; // Update with your actual eye image path
import eyeOffIcon from '../Images/hide.png'; // Update with your actual eye-off image path
import { AuthContext } from '../Components/AuthContext';
import LoginModal from '../Components/LoginModal';
import axios from 'axios';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isExpanded, setIsExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640); 
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isDropdownVisibleSearch, setIsDropdownVisibleSearch] = useState(false);
  const inputRef = useRef(null);
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [showLogin, setShowLogin] = useState(true);
  const [passwordShownLogin, setPasswordShownLogin] = useState(false);
  const [passwordShownRegister, setPasswordShownRegister] = useState(false);
  const [confirmpasswordShownRegister, setConfirmpasswordShownRegister] = useState(false);
  const [isVerifyEmailModalVisible, setIsVerifyEmailModalVisible] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [firstNameError, setFirstNameError] = useState('');
  const [lastNameError, setLastNameError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');
  const [verificationCode, setVerificationCode] = useState(new Array(6).fill(''));
  const [verificationCodeError, setVerificationCodeError] = useState('');
  const { token, setToken, userData, setUserData  } = useContext(AuthContext); 
  const [forgotPasswordStep, setForgotPasswordStep] = useState(0); 
  const [isForgotPasswordModalVisible, setIsForgotPasswordModalVisible] = useState(false);
  const [resetToken, setResetToken] = useState('');
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isProductsDropdownVisible, setIsProductsDropdownVisible] = useState(false);
  const [products, setProducts] = useState([]);
  const [isCollectionsDropdownVisible, setIsCollectionsDropdownVisible] = useState(false);
  const [collections, setCollections] = useState([]);
  const [categories, setCategories] = useState([]);
  const [emptyMessage, setEmptyMessage] = useState('');

  const handleLoginSuccess = () => {
    window.location.reload(); // Reload the entire page on login success
  };

  const byLetter = products.reduce((acc, p) => {
    const L = p.name.charAt(0).toUpperCase();
    acc[L] = acc[L] || [];
    acc[L].push(p);
    return acc;
  }, {});
  
  // 2) get a sorted array of letters
  const letters = Object.keys(byLetter).sort();

  useEffect(() => {
    // Load token from localStorage if it exists
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      setToken(storedToken);
    }
  
    // Check if the user is logged in via cookies
    const isLoggedIn = document.cookie.split('; ').find(row => row.startsWith('isLoggedIn='));
    if (isLoggedIn && isLoggedIn.split('=')[1] === 'true') {
      const storedFirstName = localStorage.getItem('firstName');
      if (storedFirstName) {
        setFirstName(storedFirstName); // Restore the user's name
      }
    }
  }, []); // Run this only on the initial load
  


  const openVerifyEmailModal = () => {
    setIsVerifyEmailModalVisible(true);
    setIsModalVisible(false);
    clearFields();
  };

  const togglePasswordLoginVisibility = () => {
    setPasswordShownLogin(!passwordShownLogin);
  };

  const togglePasswordRegisterVisibility = () => {
    setPasswordShownRegister(!passwordShownRegister);
  };
  const toggleconfirmPasswordRegisterVisibility = () => {
    setConfirmpasswordShownRegister(!confirmpasswordShownRegister);
  };

  const openModal = () => {
    setIsModalVisible(true);
  };
  
  const toggleModalContent = () => {
    setShowLogin((prevShowLogin) => !prevShowLogin);
  };

  const clearFields = () => {
    setEmail('');
    setPassword('');
    setLastName('');
    setConfirmPassword('');
    setVerificationCode(new Array(6).fill(''));
    setErrorMessage('');
    setEmailError('');
    setPasswordError('');
    setFirstNameError('');
    setLastNameError('');
    setConfirmPasswordError('');
    setVerificationCodeError('');
  };

  // Update 'isMobile' based on screen width
  useEffect(() => {
      const handleResize = () => {
          setIsMobile(window.innerWidth < 640);
      };

      window.addEventListener('resize', handleResize);
      return () => {
          window.removeEventListener('resize', handleResize);
      };
  }, []);

  const inputStyle = {
    transition: 'width 300ms ease-in-out', // Ensure transition applies to width change
    backgroundColor: "#E1E1E1",
    width: isExpanded ? '16rem' : '6rem', // Use rem units equivalent to Tailwind's w-64 and w-24
  };

   const toggleInput = () => {
    if (!isMobile) {
      setIsExpanded(!isExpanded); // Toggle the expanded state
    }
  };

   // Fetch search results
   const handleSearch = (query) => {
    setSearchQuery(query);
    setEmptyMessage(''); 

    if (!query || query.length < 4) {
      setSearchResults([]);
      setIsDropdownVisibleSearch(false);
      return;
    }
  
    axios
      .post('https://backend.printtrio.co.uk/api/product/get-products', { search: query })
      .then((response) => {
        console.log('Search API Response:', response.data); // Debug log
        if (response.data.success && response.data.data.length > 0) {
          setSearchResults(response.data.data);
          setIsDropdownVisibleSearch(true);
        } else if (response.data.success && response.data.data.length === 0) {
        // Handle empty data case
        setSearchResults([]);
        setIsDropdownVisibleSearch(true);
        setEmptyMessage('No results found'); // Set the empty message
      } else {
          setSearchResults([]);
          setIsDropdownVisibleSearch(false);
        }
      })
      .catch((error) => {
        console.error('API Call Failed:', error); // Log any API error
        setSearchResults([]);
        setIsDropdownVisibleSearch(false);
      });
  };
  
  

  const handleSearchClick = () => {
    handleSearch(searchQuery); // Call handleSearch with the current query
  };
  

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(event.target) &&
        !event.target.closest('.search-dropdown') // Prevent hiding when clicking inside dropdown
      ) {
        setIsDropdownVisibleSearch(false);
      }
    };
  
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  

  
  useEffect(() => {
      if (!isMobile) {
          const handleClickOutside = (event) => {
              if (inputRef.current && !inputRef.current.contains(event.target)) {
                  setIsExpanded(false);
              }
          };

          document.addEventListener('mousedown', handleClickOutside);
          return () => {
              document.removeEventListener('mousedown', handleClickOutside);
          };
      }
  }, [isMobile, inputRef]);

  const toggleMenu = () => {
    setIsMenuVisible(!isMenuVisible); 
  };
  
  useEffect(() => {
    const storedFirstName = localStorage.getItem("firstName");
    const storedLastName = localStorage.getItem("lastName");
  
    console.log("Stored First Name:", storedFirstName);
    console.log("Stored Last Name:", storedLastName);
  
    if (storedFirstName) {
      setUserData((prev) => ({ ...prev, firstName: storedFirstName, lastName: storedLastName }));
    }
  }, []);
  
  
  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage(''); // Clear any previous error messages
    setEmailError('');
    setPasswordError('');

    let hasError = false;

    if (!email) {
      setEmailError('Email is required.');
      hasError = true;
    }

    if (!password) {
      setPasswordError('Password is required.');
      hasError = true;
    }

    if (hasError) {
      return;
    }

    const response = await fetch('https://backend.printtrio.co.uk/api/auth/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email, password })
    });

    const data = await response.json();
    if (data.success) {
      console.log('Login successful:', data);
      setFirstName(data.data.user.first_name);
      setToken(data.data.token); // Save token in state
      localStorage.setItem('token', data.data.token);
      localStorage.setItem('firstName', data.data.user.first_name);
      document.cookie = "isLoggedIn=true; path=/"; // Save login status in cookies
      setIsModalVisible(false);
      clearFields();
    } else {
      // Handle login error
      setErrorMessage('Invalid email or password.');
      console.error('Login failed:', data.errors);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setErrorMessage(''); // Clear any previous error messages
    setEmailError('');
    setPasswordError('');
    setFirstNameError('');
    setLastNameError('');
    setConfirmPasswordError('');
  
    let hasError = false;
  
    if (!firstName) {
      setFirstNameError('First name is required.');
      hasError = true;
    }
  
    if (!lastName) {
      setLastNameError('Last name is required.');
      hasError = true;
    }
  
    if (!email) {
      setEmailError('Email is required.');
      hasError = true;
    }
  
    if (!password) {
      setPasswordError('Password is required.');
      hasError = true;
    } else {
      if (password.length < 8) {
        setPasswordError('The password must be at least 8 characters.');
        hasError = true;
      }
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
      if (!passwordRegex.test(password)) {
        setPasswordError('The password format is invalid. It must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one digit, and one special character.');
        hasError = true;
      }
    }
  
    if (!confirmPassword) {
      setConfirmPasswordError('Confirm password is required.');
      hasError = true;
    }
  
    if (password !== confirmPassword) {
      setConfirmPasswordError('Passwords do not match.');
      hasError = true;
    }
  
    if (hasError) {
      return;
    }
  
    try {
      const response = await fetch('https://backend.printtrio.co.uk/api/auth/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ first_name: firstName, last_name: lastName, email, password, password_confirmation: confirmPassword })
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.errors && errorData.errors.email && errorData.errors.email[0] === "The email has already been taken.") {
          setEmailError('The email has already been taken.');
        } else if (errorData.errors && errorData.errors.password) {
          setPasswordError(errorData.errors.password[0]);
        } else {
          setErrorMessage('Registration failed.');
        }
      } else {
        const data = await response.json();
        // Handle successful registration, e.g., store token, redirect, etc.
        console.log('Registration successful:', data);
        setToken(data.data.token);
        openVerifyEmailModal();
        clearFields();
      }
    } catch (error) {
      console.error('Registration failed:', error);
      setErrorMessage('Registration failed. Please try again later.');
    }
  };
  
  const handleVerifyCode = async (e) => {
    e.preventDefault();
    setVerificationCodeError('');

    if (verificationCode.some((code) => code === '')) {
      setVerificationCodeError('Please fill in all code fields.');
      return;
    }

    const code = verificationCode.join('');

    const response = await fetch('https://backend.printtrio.co.uk/api/auth/verify/check-code', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ token, code })
    });

    const data = await response.json();
    if (data.success) {
      console.log('Verification successful:', data);
      setIsVerifyEmailModalVisible(false);
      clearFields();
      setFirstName(firstName);

    } else {
      setVerificationCodeError('Invalid verification code. Please try again.');
      console.error('Verification failed:', data.errors);
    }
  };

  const handleResendCode = async () => {
    const response = await fetch('https://backend.printtrio.co.uk/api/auth/verify/rest-code', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ token })
    });

    const data = await response.json();
    if (data.success) {
      console.log('Code resent successfully:', data);
      setToken(data.data.token);
      setFirstName(firstName);

    } else {
      setErrorMessage('Failed to resend code. Please try again.');
      console.error('Resend code failed:', data.errors);
    }
  };

  const handleCodeChange = (element, index) => {
    if (isNaN(element.value)) return false;

    setVerificationCode([...verificationCode.map((d, idx) => (idx === index ? element.value : d))]);

    // Focus next input field if current field is filled
    if (element.nextSibling && element.value) {
      element.nextSibling.focus();
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setEmailError('');

    if (!email) {
      setEmailError('Email is required.');
      return;
    }

    try {
      // Send forgot password request to the server
      const response = await fetch('https://backend.printtrio.co.uk/api/auth/forget-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email })
      });

      const data = await response.json();

      if (data.success) {
        setResetToken(data.data.token); // Store the token
        setForgotPasswordStep(1); // Move to code input step
        console.log('Forgot password email sent:', data);
      } else {
        if (data.errors && data.errors.email && data.errors.email[0] === "The selected email is invalid.") {
          setEmailError('The selected email is invalid.');
        } else {
          setErrorMessage('Failed to send forgot password email.');
        }
        console.error('Forgot password failed:', data.errors);
      }
    } catch (error) {
      setErrorMessage('The selected email is invalid.');
      console.error('Error:', error);
    }
  };



  const handleForgotPasswordVerifyCode = async (e) => {
    e.preventDefault();
    setVerificationCodeError('');

    if (verificationCode.some((code) => code === '')) {
      setVerificationCodeError('Please fill in all code fields.');
      return;
    }

    const code = verificationCode.join('');

    // Send verify code request to the server
    const response = await fetch('https://backend.printtrio.co.uk/api/auth/forget-password/check-code', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ token: resetToken, code })
    });

    const data = await response.json();
    if (data.success) {
      setForgotPasswordStep(2); // Move to new password input step
      console.log('Forgot password code verified:', data);
    } else {
      setVerificationCodeError('Invalid verification code. Please try again.');
      console.error('Verify code failed:', data.errors);
    }
  };


  const handleForgotPasswordReset = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setPasswordError('');
    setConfirmPasswordError('');

    let hasError = false;

    if (!password) {
      setPasswordError('Password is required.');
      hasError = true;
    } else {
      if (password.length < 8) {
        setPasswordError('The password must be at least 8 characters.');
        hasError = true;
      }
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
      if (!passwordRegex.test(password)) {
        setPasswordError('The password format is invalid. It must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one digit, and one special character.');
        hasError = true;
      }
    }

    if (!confirmPassword) {
      setConfirmPasswordError('Confirm password is required.');
      hasError = true;
    }

    if (password !== confirmPassword) {
      setConfirmPasswordError('Passwords do not match.');
      hasError = true;
    }

    if (hasError) {
      return;
    }

    // Send reset password request to the server
    const response = await fetch('https://backend.printtrio.co.uk/api/auth/forget-password/update', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ token: resetToken, password, password_confirmation: confirmPassword })
    });

    const data = await response.json();
    if (data.success) {
      setForgotPasswordStep(0);
      clearFields();
      setIsModalVisible(true); // Show login form
      setIsForgotPasswordModalVisible(false); // Hide forgot password modal
      console.log('Password reset successful:', data);
    } else {
      setErrorMessage('Failed to reset password.');
      console.error('Reset password failed:', data.errors);
    }
  };

  const handleLogout = async () => {
    try {
      // Fetch token from localStorage if not in state
      let token = localStorage.getItem('token');
      if (!token) {
        alert('No token found. Please log in first.');
        return;
      }
  
      const response = await fetch('https://backend.printtrio.co.uk/api/profile/logout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`, // Ensure token is included
        },
        body: JSON.stringify({
          email,    // Send the email used during login
          password, // Send the password used during login
        }),
      });
  
      if (!response.ok) {
        throw new Error('Failed to log out.');
      }
  
      const data = await response.json();
  
      if (data.success) {
        console.log('Logout successful:', data.data.message);
  
        // Clear state and local storage
        setUserData({});
        setFirstName(''); 
        setToken('');     
        setIsDropdownVisible(false); 
  
        localStorage.removeItem('firstName');
        localStorage.removeItem('lastName'); 
        localStorage.removeItem('image');    
        localStorage.removeItem('token');
  
        document.cookie = "isLoggedIn=false; path=/";
  
        navigate('/');
       
      } else {
        console.error('Logout failed:', data.errors || 'Unknown error');
        alert('Logout failed. Please try again.');
      }
    } catch (error) {
      console.error('Error logging out:', error);
     
    }
  };
  
  
   // Fetch products from API
   useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.post(
          'https://backend.printtrio.co.uk/api/product/get-products'
        );
        if (response.data.success) {
          const sortedProducts = response.data.data
            .filter(p => p.is_active === 1) // Optional: if `is_active` exists
            .sort((a, b) => a.ordering - b.ordering); // Sort by ordering
  
          // setProducts(sortedProducts.slice(0, 6)); // Limit to first 6
          setProducts(sortedProducts); 
        }
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };
  
    fetchProducts();
  }, []);
  

  const handleProductClick = (productId) => {
    navigate('/product', {
      state: {
        scrollToPromo: true,
        productId,
      },
    });
  };
  
  
  useEffect(() => {
    const fetchCollections = async () => {
      try {
        const response = await fetch(
          'https://backend.printtrio.co.uk/api/category/get-collection'
        );
        const result = await response.json();
        if (result.success) {
          const sortedCollections = result.data
            .filter(col => col.is_active === 1) // Optional: only include active ones
            .sort((a, b) => a.ordering - b.ordering); // Sort by ordering
  
          setCollections(sortedCollections.slice(0, 6)); // Limit to first 6
        }
      } catch (error) {
        console.error('Error fetching collections:', error);
      }
    };
  
    fetchCollections();
  }, []);
  

  const handleCollectionClick = (collection) => {
    axios.post('https://backend.printtrio.co.uk/api/product/get-products', { categoryId: collection.id })
        .then(response => {
            if (response.data.success) {
                navigate('/collection', {
                    state: {
                        scrollToPromo: true,
                        products: response.data.data, // Fetched products
                        collectionName: collection.name, // Collection name
                        collectionDescription: collection.description, // Collection description
                        collectionImage: collection.image, // Collection image
                        collectionBanner: collection.banner,
                    },
                });
            }
        })
        .catch(error => {
            console.error('Error fetching the products:', error);
        });
};

  
  
    // Fetch categories 
    useEffect(() => {
      axios
        .get('https://backend.printtrio.co.uk/api/category/get-category')
        .then((res) => {
          if (res.data.success) {
            const sortedCategories = res.data.data
              .filter(cat => cat.is_active === 1)
              .sort((a, b) => a.ordering - b.ordering); // Sort by ordering ascending
            setCategories(sortedCategories.slice(0, 6));
          }
        })
        .catch((err) => console.error(err));
    }, []);

    
  
    const handleCategoryClick = (categoryId, categoryName, banner, description) => {
      navigate('/Category-name', { state: { categoryId, categoryName, banner, description, scrollToPromo: true } });
    };


    
  return (
    <div>
    <header className="bg-white p-4 flex justify-between items-center  px-4 xl:px-0  border-b border-gray-300 z-20 relative max-w-screen-xl mx-auto  relative">
       <Link to="/">
         <img src={logo} alt="Printtrio Logo" className="h-8 sm:h-12" />
       </Link>
     
      <div className="flex items-center space-x-4 space-x-8">
       
      <div
  className="flex items-center ml-2 md:ml-4 bg-white border rounded-full overflow-hidden"
  style={{ backgroundColor: "#E1E1E1" }}
>
  <button className="p-2 search-button" onClick={handleSearchClick}>
    <img
      src={search}
      alt="Search"
      className="h-4 sm:h-7 w-4 sm:w-10 ml-2 md:ml-0 object-contain"
    />
  </button>

  {/* Relative container for input and dropdown */}
  <div className="relative">
    <input
      ref={inputRef}
      className="pl-4 pr-2 py-2 outline-none w-full bg-transparent"
      type="search"
      placeholder="Search"
      style={inputStyle}
      value={searchQuery}
      onFocus={toggleInput}
      onBlur={(e) => {
        // Prevent dropdown from hiding if clicking inside the dropdown
        if (!e.relatedTarget || !e.relatedTarget.classList.contains('dropdown-item')) {
          setIsDropdownVisibleSearch(false);
        }
      }}
      onChange={(e) => handleSearch(e.target.value)}
    />
  </div>

  {isDropdownVisibleSearch && (
  <div
    className="absolute top-full right-22 bg-white border border-gray-300 shadow-md mt-1 rounded-md z-50"
    style={{ width: "max-content", minWidth: "17%" }}
  >
    {searchResults.length > 0 ? (
      searchResults.map((result) => (
        <div
          key={result.id}
          className="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer dropdown-item"
          onMouseDown={() => handleProductClick(result.id)} // Use onMouseDown for immediate execution
        >
          <img
            src={result.default_image}
            alt={result.name}
            className="w-8 h-8 rounded-full object-cover mr-3"
          />
          <span className="text-sm font-medium text-gray-700">{result.name}</span>
        </div>
      ))
    ) : emptyMessage ? (
      <div className="flex items-center px-4 py-2 text-gray-500">
        {emptyMessage}
      </div>
    ) : null}
  </div>
)}

</div>




<div 
  className="relative block " 
  onMouseEnter={() => setIsDropdownVisible(true)}
  onMouseLeave={() => setIsDropdownVisible(false)}
>
<button
            onClick={!userData.firstName ? openModal : () => setIsDropdownVisible(!isDropdownVisible)}
            className="flex items-center justify-center text-xs sm:text-base cursor-pointer"
          >
            {userData.firstName ? (
              <>
                Hi {userData.firstName},
                <img src={arrowDownImage} alt="Arrow down" className="ml-2 mt-2 w-3 h-auto" />
              </>
            ) : (
              'Join'
            )}
          </button>

          {isDropdownVisible && userData.firstName && (
    <div className="absolute right-0 left-0 bg-white appearance-none text-pink-500  border-none  shadow-md rounded mt-0 py-2 w-28 md:w-48">
      <Link to="/dashboard" className="block px-4 py-2 text-xs md:text-md font-semibold text-gray-800 hover:bg-gray-200">Dashboard</Link>
      <Link to="/dashboard"  state={{ activeLink: 'History' }} className="block px-4 py-2 text-xs md:text-md font-semibold text-gray-800 hover:bg-gray-200">History</Link>
      <Link to="/dashboard"  state={{ activeLink: 'Profile' }} className="block px-4 py-2 text-xs md:text-md font-semibold text-gray-800 hover:bg-gray-200">Account Profile</Link>
      <button onClick={handleLogout} className="block w-full text-left px-4 py-2 text-xs md:text-md font-semibold text-gray-800 hover:bg-gray-200">Logout</button>
    </div>
  )}
</div>





<button 
  className="flex items-center justify-center"
  onClick={() => {
    if (token) {
      // If the user is logged in, navigate to the Cart page
      navigate('/Cart', { state: { token } });  // Passing the token as part of the state
    } else {
      // If the user is not logged in, open the login modal
      setIsModalVisible(true);
    }
  }}
>
  <img src={bag} alt="Printtrio bag" className="h-5 sm:h-6 w-5 sm:w-6" />
</button>

      </div>
    </header>

    {/* {isModalVisible && (
      <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto w-full z-50" id="my-modal">
        <div className="relative top-10 mx-auto p-5 border w-11/12 sm:w-1/3 shadow-lg rounded-xl bg-white">
          <div className="absolute top-1 right-1 pt-4 pr-4">
            <button onClick={() => setIsModalVisible(false)} className="text-gray-600 hover:text-gray-900">
              <img src={closeIcon} alt="Close" className="h-7 w-7" />
            </button>
          </div>
          {showLogin ? (
            <div className="mt-3 text-start">
              <div className="mt-4 px-7">
                <h1 className="text-xl leading-6 font-bold text-gray-900">Login</h1>
              </div>
              <form className="mt-2 px-7 py-3" onSubmit={handleLogin}>
                <label>Email</label>
                <input
                  type="email"
                  placeholder="username@gmail.com"
                  className="mt-2 mb-2 p-2 border rounded-xl w-full"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                {emailError && (
                  <p className="text-red-500 text-sm">{emailError}</p>
                )}
                <label>Password</label>
                <div className="mt-2 relative">
                  <input
                    type={passwordShownLogin ? "text" : "password"}
                    placeholder="Password"
                    className="mt-2 p-2 border rounded-xl w-full"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    onClick={togglePasswordLoginVisibility}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5"
                  >
                    <img
                      src={passwordShownLogin ? eyeOffIcon : eyeIcon}
                      alt="Toggle Password Visibility"
                      className="h-6 w-6 mt-3 text-gray-700"
                    />
                  </button>
                </div>
                {passwordError && (
                  <p className="text-red-500 text-sm">{passwordError}</p>
                )}
                {errorMessage && (
                  <p className="text-red-500 text-sm">{errorMessage}</p>
                )}
                <div className="flex items-center justify-between mt-3">
                  <label className="flex items-center">
                    <input type="checkbox" className="form-checkbox h-4 w-4 text-pink-600" /><span className="ml-2 text-sm text-gray-600">Remember me</span>
                  </label>
                  <div className="text-sm">
                  <a href="#" className="font-medium text-[#EC008C]" onClick={() => { setForgotPasswordStep(0); setIsForgotPasswordModalVisible(true); setIsModalVisible(false); }}>Forgot Password?</a>


                  </div>
                </div>
                <div className="items-center py-3">
                  <button id="ok-btn" type="submit" className="px-4 py-2 bg-[#EC008C] text-white text-xl font-semibold rounded-full w-full shadow-sm focus:outline-none focus:ring-2">
                    Sign in
                  </button>
                </div>
              </form>
              <div className="flex items-center justify-center px-4 mb-5 gap-2">
                <span className="text-sm text-[#EC008C]">Don’t have an account yet?</span>
                <a href="#" className="font-medium text-gray-500 hover:text-[#EC008C]" onClick={toggleModalContent}>Register for free</a>
              </div>
            </div>
          ) : (
            <div className="mt-3 text-start">
              <div className="px-7 py-3">
                <h1 className="text-xl leading-6 font-bold text-gray-900">Register</h1>
              </div>
              <form className="mt-2 px-7 py-2" onSubmit={handleRegister}>
                <label className="text-sm">First Name</label>
                <input
                  type="text"
                  placeholder="First Name"
                  className="mt-2 mb-2 p-2 border rounded-xl w-full"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
                {firstNameError && (
                  <p className="text-red-500 text-sm">{firstNameError}</p>
                )}
                <label className="text-sm">Last Name</label>
                <input
                  type="text"
                  placeholder="Last Name"
                  className="mt-2 mb-2 p-2 border rounded-xl w-full"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
                {lastNameError && (
                  <p className="text-red-500 text-sm">{lastNameError}</p>
                )}
                <label className="text-sm">Email</label>
                <input
                  type="email"
                  placeholder="username@gmail.com"
                  className="mt-2 mb-2 p-2 border rounded-xl w-full"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                {emailError && (
                  <p className="text-red-500 text-sm">{emailError}</p>
                )}
                <label className="text-sm">Password</label>
                <div className="mb-2 relative">
                  <input
                    type={passwordShownRegister ? "text" : "password"}
                    placeholder="Password"
                    className="mt-2 p-2 border rounded-xl w-full"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    onClick={togglePasswordRegisterVisibility}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5"
                  >
                    <img
                      src={passwordShownRegister ? eyeOffIcon : eyeIcon}
                      alt="Toggle Password Visibility"
                      className="h-6 w-6 mt-3 text-gray-700"
                    />
                  </button>
                </div>
                {passwordError && (
                  <p className="text-red-500 text-sm">{passwordError}</p>
                )}
                <label className="text-sm">Confirm Password</label>
                <div className="mb-2 relative">
                  <input
                    type={confirmpasswordShownRegister ? "text" : "password"}
                    placeholder="Confirm Password"
                    className="mt-2 p-2 border rounded-xl w-full"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    onClick={toggleconfirmPasswordRegisterVisibility}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5"
                  >
                    <img
                      src={confirmpasswordShownRegister ? eyeOffIcon : eyeIcon}
                      alt="Toggle Confirm Password Visibility"
                      className="h-6 w-6 mt-3 text-gray-700"
                    />
                  </button>
                </div>
                {confirmPasswordError && (
                  <p className="text-red-500 text-sm">{confirmPasswordError}</p>
                )}
                {errorMessage && (
                  <p className="text-red-500 text-sm">{errorMessage}</p>
                )}
                <div className="items-center py-3">
                  <button id="ok-btn" type="submit" className="px-4 py-2 bg-[#EC008C] text-white text-xl font-semibold rounded-full w-full shadow-sm focus:outline-none focus:ring-2">
                    Register
                  </button>
                </div>
              </form>
              <div className="flex items-center justify-center px-4 mb-5 gap-2">
                <span className="text-sm text-[#EC008C]">Already have an account?</span>
                <a href="#" className="font-medium text-gray-500 hover:text-[#EC008C]" onClick={toggleModalContent}>Sign in</a>
              </div>
            </div>
          )}
        </div>
      </div>
    )}

    {isVerifyEmailModalVisible && (
      <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
        <div className="relative top-20 mx-auto p-5 border w-11/12 sm:w-1/3 md:w-1/2 xl:w-1/3 shadow-lg rounded-xl bg-white">
          <div className="absolute top-1 right-1 pt-4 pr-4">
            <button onClick={() => setIsVerifyEmailModalVisible(false)} className="text-gray-600 hover:text-gray-900">
              <img src={closeIcon} alt="Close" className="h-7 w-7" />
            </button>
          </div>
          <form className="text-center mb-5" onSubmit={handleVerifyCode}>
            <div className="text-start px-10">
              <h2 className="text-xl font-bold text-gray-900">Please Verify Email</h2>
              <p className="text-xs text-gray-600 mt-2 mb-8">We've sent an email with instructions. Please add the code here to verify your email.</p>
            </div>
            <div className="flex justify-center gap-5 mb-10">
              {verificationCode.map((data, index) => (
                <input
                  key={index}
                  type="text"
                  maxLength="1"
                  className="w-12 h-12 text-center form-input border rounded-md"
                  value={data}
                  onChange={(e) => handleCodeChange(e.target, index)}
                  onFocus={(e) => e.target.select()}
                />
              ))}
            </div>
            {verificationCodeError && (
              <p className="text-red-500 text-sm mb-5">{verificationCodeError}</p>
            )}
            <button className="text-white bg-[#EC008C] px-4 py-2 mb-3 rounded-full w-3/4 font-bold" type="submit">Submit</button>
            <p className="text-xs text-[#EC008C] mt-3">
              I didn't receive the code, <a href="#" className="text-gray-500 hover:underline" onClick={handleResendCode}>Resend It Again</a>
            </p>
          </form>
        </div>
      </div>
    )}

{isForgotPasswordModalVisible && forgotPasswordStep === 0 && (
  <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto w-full z-50">
    <div className="relative top-10 mx-auto p-5 border w-11/12 sm:w-1/3 shadow-lg rounded-xl bg-white">
      <div className="absolute top-1 right-1 pt-4 pr-4">
        <button onClick={() => { setIsForgotPasswordModalVisible(false); setForgotPasswordStep(0); }} className="text-gray-600 hover:text-gray-900">
          <img src={closeIcon} alt="Close" className="h-7 w-7" />
        </button>
      </div>
      <div className="mt-3 text-start">
        <div className="mt-4 px-7">
          <h1 className="text-xl leading-6 font-bold text-gray-900">Forgot Password</h1>
        </div>
        <form className="mt-2 px-7 py-3" onSubmit={handleForgotPassword}>
          <label>Email</label>
          <input
            type="email"
            placeholder="username@gmail.com"
            className="mt-2 mb-2 p-2 border rounded-xl w-full"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {emailError && (
            <p className="text-red-500 text-sm">{emailError}</p>
          )}
          {errorMessage && (
            <p className="text-red-500 text-sm">{errorMessage}</p>
          )}
          <div className="items-center py-3">
            <button id="ok-btn" type="submit" className="px-4 py-2 bg-[#EC008C] text-white text-xl font-semibold rounded-full w-full shadow-sm focus:outline-none focus:ring-2">
              Next
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
)}


{forgotPasswordStep === 1 && (
  <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto w-full z-50">
    <div className="relative top-10 mx-auto p-5 border w-11/12 sm:w-1/3 shadow-lg rounded-xl bg-white">
      <div className="absolute top-1 right-1 pt-4 pr-4">
        <button onClick={() => { setIsModalVisible(false); setForgotPasswordStep(0); }} className="text-gray-600 hover:text-gray-900">
          <img src={closeIcon} alt="Close" className="h-7 w-7" />
        </button>
      </div>
      <div className="mt-3 text-start">
        <div className="mt-4 px-7">
          <h1 className="text-xl leading-6 font-bold text-gray-900">Verify Code</h1>
        </div>
        <form className="mt-2 px-7 py-3" onSubmit={handleForgotPasswordVerifyCode}>
          <div className="flex justify-center gap-5 mb-10">
            {verificationCode.map((data, index) => (
              <input
                key={index}
                type="text"
                maxLength="1"
                className="w-12 h-12 text-center form-input border rounded-md"
                value={data}
                onChange={(e) => handleCodeChange(e.target, index)}
                onFocus={(e) => e.target.select()}
              />
            ))}
          </div>
          {verificationCodeError && (
            <p className="text-red-500 text-sm">{verificationCodeError}</p>
          )}
          <div className="items-center py-3">
            <button id="ok-btn" type="submit" className="px-4 py-2 bg-[#EC008C] text-white text-xl font-semibold rounded-full w-full shadow-sm focus:outline-none focus:ring-2">
              Next
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
)}

{forgotPasswordStep === 2 && (
  <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto w-full z-50">
    <div className="relative top-10 mx-auto p-5 border w-11/12 sm:w-1/3 shadow-lg rounded-xl bg-white">
      <div className="absolute top-1 right-1 pt-4 pr-4">
        <button onClick={() => { setIsModalVisible(false); setForgotPasswordStep(0); }} className="text-gray-600 hover:text-gray-900">
          <img src={closeIcon} alt="Close" className="h-7 w-7" />
        </button>
      </div>
      <div className="mt-3 text-start">
        <div className="mt-4 px-7">
          <h1 className="text-xl leading-6 font-bold text-gray-900">Reset Password</h1>
        </div>
        <form className="mt-2 px-7 py-3" onSubmit={handleForgotPasswordReset}>
          <label>Password</label>
          <div className="mb-2 relative">
            <input
              type={passwordShownRegister ? "text" : "password"}
              placeholder="Password"
              className="mt-2 p-2 border rounded-xl w-full"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="button"
              onClick={togglePasswordRegisterVisibility}
              className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5"
            >
              <img
                src={passwordShownRegister ? eyeOffIcon : eyeIcon}
                alt="Toggle Password Visibility"
                className="h-6 w-6 mt-3 text-gray-700"
              />
            </button>
          </div>
          {passwordError && (
            <p className="text-red-500 text-sm">{passwordError}</p>
          )}
          <label>Confirm Password</label>
          <div className="mb-2 relative">
            <input
              type={confirmpasswordShownRegister ? "text" : "password"}
              placeholder="Confirm Password"
              className="mt-2 p-2 border rounded-xl w-full"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <button
              type="button"
              onClick={toggleconfirmPasswordRegisterVisibility}
              className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5"
            >
              <img
                src={confirmpasswordShownRegister ? eyeOffIcon : eyeIcon}
                alt="Toggle Confirm Password Visibility"
                className="h-6 w-6 mt-3 text-gray-700"
              />
            </button>
          </div>
          {confirmPasswordError && (
            <p className="text-red-500 text-sm">{confirmPasswordError}</p>
          )}
          {errorMessage && (
            <p className="text-red-500 text-sm">{errorMessage}</p>
          )}
          <div className="items-center py-3">
            <button id="ok-btn" type="submit" className="px-4 py-2 bg-[#EC008C] text-white text-xl font-semibold rounded-full w-full shadow-sm focus:outline-none focus:ring-2">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
)} */}

<LoginModal
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        onLoginSuccess={handleLoginSuccess}  // Pass the success handler
      />


    <div className="flex justify-end pr-2 ">
      <button onClick={toggleMenu} className="p-2 xl:hidden">
        <img src={menuIcon} alt="Menu" className="h-6 w-6" />
      </button>
    </div>
    <nav className={`bg-white py-3 ${isMenuVisible ? 'block' : 'hidden'} xl:block z-10 max-w-screen-2xl mx-auto  relative`}>
    <ul className="flex flex-col xl:flex-row justify-between items-start xl:items-center px-4 xl:px-32 text-left xl:text-center">
    <div className="flex flex-col xl:flex-row items-start xl:items-center space-x-0 xl:space-x-4 space-y-2 xl:space-y-0">
    <li
  className="relative flex items-center text-xs sm:text-base text-black hover:text-pink-500 cursor-pointer z-50"
  onMouseEnter={() => setIsProductsDropdownVisible(true)}
  onMouseLeave={() => setIsProductsDropdownVisible(false)}
>
  Products
  <img
    src={arrowDownImage}
    alt="Arrow down"
    className="ml-3 w-3 h-auto"
  />

  {isProductsDropdownVisible && (
    <div
      className="absolute left-0 right-0 top-full bg-white shadow-lg z-50 p-6 z-50"
      style={{ minWidth: "60rem" }}
    >
      <div className="w-full max-w-screen-xl mx-auto z-50">
        {(() => {
          // split your letters into two halves so they pair
          const mid = Math.ceil(letters.length / 2);
          const firstHalf = letters.slice(0, mid);
          const secondHalf = letters.slice(mid);

          return (
            <div
              className="
                grid
                grid-cols-1        /* mobile: 1 col */
                sm:grid-cols-2     /* ≥640px: 2 cols */
                md:grid-cols-2     /* ≥768px: 3 cols */
                xl:grid-cols-4     /* ≥1280px: 4 cols */
                gap-x-8
                gap-y-6
                z-50
              "
            >
              {firstHalf.map((letter, idx) => (
                <div key={letter} className="space-y-6">
                  {/* Top letter block */}
                  <div>
                    <h3 className="text-pink-500 font-semibold mb-2 text-left">
                      {letter}
                    </h3>
                    <ul className="space-y-1 text-left z-50">
                      {byLetter[letter].map(p => (
                        <li
                          key={p.id}
                          onClick={() => handleProductClick(p.id)}
                          className="cursor-pointer hover:text-pink-500 z-50"
                        >
                          {p.name}
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Paired bottom letter block */}
                  {secondHalf[idx] && (
                    <div>
                      <h3 className="text-pink-500 font-semibold mb-2 text-left">
                        {secondHalf[idx]}
                      </h3>
                      <ul className="space-y-1 text-left">
                        {byLetter[secondHalf[idx]].map(p => (
                          <li
                            key={p.id}
                            onClick={() => handleProductClick(p.id)}
                            className="cursor-pointer hover:text-pink-500"
                          >
                            {p.name}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              ))}
            </div>
          );
        })()}
      </div>
    </div>
  )}
</li>



{collections.length > 0 && (
<li 
  className="relative text-black hover:text-pink-500 cursor-pointer flex items-center text-xs sm:text-base"
  onMouseEnter={() => setIsCollectionsDropdownVisible(true)}
  onMouseLeave={() => setIsCollectionsDropdownVisible(false)}
> 
  Collections <img src={arrowDownImage} alt="Arrow down" className="ml-3 mt-0 md:mt-2 w-3 h-auto" />
  {isCollectionsDropdownVisible && (
    <div className="absolute right-0 left-0 top-6 bg-white appearance-none text-pink-500 border-none shadow-md rounded mt-0 py-2 w-48 md:w-48">
      <ul className="py-1 text-left">
      {collections.map((collection) => (
        <li 
        className="block px-4 py-2 text-xs md:text-md font-semibold text-gray-800 hover:bg-gray-200"
        onClick={() => handleCollectionClick(collection)}
        >
           {collection.name}
        </li>
      
        ))}
      </ul>
    </div>
  )}
</li>
     )}
        </div>

        <div className="flex flex-col xl:flex-row items-start xl:items-center space-x-0 xl:space-x-4 sm:space-x-0 space-y-2 xl:space-y-0 mt-2 sm:mt-0">
        {categories.map((category) => (
          <li 
          key={category.id}
          className="text-black hover:text-pink-500 cursor-pointer text-xs sm:text-base mt-2 xl:mt-0 text-left"
          onClick={() => handleCategoryClick(category.id, category.name, category.banner, category.description)}
          >
           {category.name}
          </li>
        
	          ))}

          <li className="mt-3 xl:mt-0 xl:ml-4">
            <Link
              to="/bespoke-request"
              className={`inline-flex min-h-[44px] items-center justify-center rounded-full px-5 py-2 text-sm font-semibold text-white shadow-md transition duration-200 ${
                location.pathname === '/bespoke-request'
                  ? 'bg-[#c81a74]'
                  : 'bg-[#EC008C] hover:bg-[#d70080]'
              }`}
            >
              Bespoke request
            </Link>
          </li>
        </div>
      </ul>
    </nav>
  </div>
  );
};

export default Navbar;
